/** The product name, in one place (the mockups' `[data-product-name]`). */
export const PRODUCT_NAME = 'AdOrchestrator';

/** `<title>` for a route: "Welcome — AdOrchestrator". */
export function pageTitle(route: string): string {
  return `${route} — ${PRODUCT_NAME}`;
}
